import React, {useState} from "react";
import items from './SliderCartelera.json';
import Slider from "react-slick";
import SlideCartelera from './SlideCartelera';

const SliderCartelera = () => {

  const [menuItem, setMenuItem] = useState(items);

    var settings = {
        className: "center",
        centerMode: true,
        dots: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 8000,
        speed: 2000,
        centerPadding: '130px',
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
        arrows: false,
        responsive: [
        {
            breakpoint: 900,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              initialSlide: 0,
              centerPadding: '240px',
              dots: true
            }
          },
          {
            breakpoint: 700,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              initialSlide: 0,
              centerPadding: '30px',
              dots: true
            }
          }
        ]
      };

    return (
        <section className="sliderCarteleraContent">
            <div>
                <Slider {...settings}>
                {
                  menuItem.map((videoBig) => {
                      return <SlideCartelera id={videoBig.id} categoria={videoBig.categoria} titulo={videoBig.titulo} screenshot={videoBig.screenshot} screenshotmobile={videoBig.screenshotmobile} resena={videoBig.resena} />
                  })
                }
                </Slider>
            </div>
        </section>
      );
    }

  

    export default SliderCartelera